module.exports = __webpack_public_path__ + "img/Image_dictionary.a52ffedb.jpg";